import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _extends from "@babel/runtime/helpers/extends";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  padding: ", "px;\n  box-sizing: border-box;\n  width: 100%;\n  ", "\n\n  @media screen and (max-width: ", "px) {\n    padding: 30px;\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from '../utils/styling/styled-components';
import { Card, CardFooter } from '../Card';

var A4_Card = function A4_Card(props) {
  return /*#__PURE__*/React.createElement(Card, _extends({}, props, {
    className: props.className
  }), props.children);
};

var paddingMap = {
  large: 80,
  medium: 50,
  small: 30,
  none: 0
};
var A4_CardContent = styled.div(_templateObject(), function (_ref) {
  var _ref$padding = _ref.padding,
      padding = _ref$padding === void 0 ? 'small' : _ref$padding;
  return paddingMap[padding];
}, function (props) {
  return props.isContentCenterAligned && "\n    margin: auto; // Makes the content take up center aligned within available space and and pins footer to the bottom.\n  ";
}, function (props) {
  return props.theme.breakpoints.sm;
});

var A4_CardFooter = function A4_CardFooter(props) {
  return /*#__PURE__*/React.createElement(CardFooter, _extends({}, props, {
    className: props.className
  }));
};

export { A4_Card, A4_CardFooter, A4_CardContent };